import React, { useEffect } from 'react';

interface Props {
  value: string;
  bodyClassName?: string;
}

export const PoweredByBanner = (props: Props) => {
  useEffect(() => {
    const classNames = props.bodyClassName?.split(' ') ?? []
    classNames.forEach(className => {
      try {
        document.body.classList.add(className);
      } catch {}
    });

    return () => {
        classNames.forEach(className => {
          try {
            document.body.classList.remove(className);
          } catch {}
        });
    }
  })

  return (
    <div className="text-center bg-dark text-white text-uppercase small p-1">
      Powered by {props.value}
    </div>
  )
}